import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const EntityLayout = ({ children }) => (
  <div>
    {children}
  </div>
);
EntityLayout.propTypes = {
  children: PropTypes.node,
};

const mapDispatchToProps = {

};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(EntityLayout);



// WEBPACK FOOTER //
// ./src/layouts/EntityLayout/EntityLayout.js